export class MyUrbisRoutingNames {
    public static readonly NAME_BASE = '';
    public static readonly NAME_URBIS = 'my-urbis';

    public static readonly ROUTE_BASE = `/${MyUrbisRoutingNames.NAME_BASE}`;
    public static readonly ROUTE_URBIS = `/${MyUrbisRoutingNames.NAME_URBIS}`;
}
